export default __webpack_public_path__ + "static/media/peopleLight.2147cd4d.svg";